import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/menus/$menuId/items")({
  component: ItemsLayout,
});

function ItemsLayout() {
  return <Outlet />;
}
